import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCookiesToast, LazyLogo, LazyProseA, LazyProseBlockquote, LazyProseCode, LazyProseEm, LazyProseH1, LazyProseH2, LazyProseH3, LazyProseH4, LazyProseH5, LazyProseH6, LazyProseHr, LazyProseImg, LazyProseLi, LazyProseOl, LazyProseP, LazyProsePre, LazyProseScript, LazyProseStrong, LazyProseTable, LazyProseTbody, LazyProseTd, LazyProseTh, LazyProseThead, LazyProseTr, LazyProseUl, LazyPrimeCheckbox, LazyPrimeDatePicker, LazyPrimeFloatLabel, LazyPrimeInputGroup, LazyPrimeInputGroupAddon, LazyPrimeInputText, LazyPrimePassword, LazyPrimeSelect, LazyPrimeTextarea, LazyPrimeToggleSwitch, LazyPrimeButton, LazyPrimeSplitButton, LazyPrimeAccordion, LazyPrimeAccordionPanel, LazyPrimeAccordionHeader, LazyPrimeAccordionContent, LazyPrimeDivider, LazyPrimeToolbar, LazyPrimeConfirmDialog, LazyPrimeDialog, LazyPrimeMenu, LazyPrimeMessage, LazyPrimeToast, LazyPrimeCarousel, LazyPrimeImage, LazyPrimeBadge, LazyPrimeProgressSpinner, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["CookiesToast", LazyCookiesToast],
["Logo", LazyLogo],
["ProseA", LazyProseA],
["ProseBlockquote", LazyProseBlockquote],
["ProseCode", LazyProseCode],
["ProseEm", LazyProseEm],
["ProseH1", LazyProseH1],
["ProseH2", LazyProseH2],
["ProseH3", LazyProseH3],
["ProseH4", LazyProseH4],
["ProseH5", LazyProseH5],
["ProseH6", LazyProseH6],
["ProseHr", LazyProseHr],
["ProseImg", LazyProseImg],
["ProseLi", LazyProseLi],
["ProseOl", LazyProseOl],
["ProseP", LazyProseP],
["ProsePre", LazyProsePre],
["ProseScript", LazyProseScript],
["ProseStrong", LazyProseStrong],
["ProseTable", LazyProseTable],
["ProseTbody", LazyProseTbody],
["ProseTd", LazyProseTd],
["ProseTh", LazyProseTh],
["ProseThead", LazyProseThead],
["ProseTr", LazyProseTr],
["ProseUl", LazyProseUl],
["PrimeCheckbox", LazyPrimeCheckbox],
["PrimeDatePicker", LazyPrimeDatePicker],
["PrimeFloatLabel", LazyPrimeFloatLabel],
["PrimeInputGroup", LazyPrimeInputGroup],
["PrimeInputGroupAddon", LazyPrimeInputGroupAddon],
["PrimeInputText", LazyPrimeInputText],
["PrimePassword", LazyPrimePassword],
["PrimeSelect", LazyPrimeSelect],
["PrimeTextarea", LazyPrimeTextarea],
["PrimeToggleSwitch", LazyPrimeToggleSwitch],
["PrimeButton", LazyPrimeButton],
["PrimeSplitButton", LazyPrimeSplitButton],
["PrimeAccordion", LazyPrimeAccordion],
["PrimeAccordionPanel", LazyPrimeAccordionPanel],
["PrimeAccordionHeader", LazyPrimeAccordionHeader],
["PrimeAccordionContent", LazyPrimeAccordionContent],
["PrimeDivider", LazyPrimeDivider],
["PrimeToolbar", LazyPrimeToolbar],
["PrimeConfirmDialog", LazyPrimeConfirmDialog],
["PrimeDialog", LazyPrimeDialog],
["PrimeMenu", LazyPrimeMenu],
["PrimeMessage", LazyPrimeMessage],
["PrimeToast", LazyPrimeToast],
["PrimeCarousel", LazyPrimeCarousel],
["PrimeImage", LazyPrimeImage],
["PrimeBadge", LazyPrimeBadge],
["PrimeProgressSpinner", LazyPrimeProgressSpinner],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
